import { combineEpics } from 'redux-observable'
import { DevicesEpics } from './Devices'
import { LicenseMgmtEpics } from './License'
import { OrganizationEpics } from './Organization/epics'
import { UserEpics } from './User/epics'
import { ClaimEpics } from './Claims/epics'
import { RolesEpics } from './Role/epics'
import { UsersEpics } from './AdminUser/epics'

const rootEpic = combineEpics(
  ...UsersEpics,
  ...RolesEpics,
  ...OrganizationEpics,
  ...DevicesEpics,
  ...UserEpics,
  ...LicenseMgmtEpics,
  ...ClaimEpics,
)

export default rootEpic
